module.exports = __webpack_public_path__ + "assets/illu-checklist-pen.b8e2ea5fa00ed0493841ee0b98b02eda.svg";